export default "__VITE_ASSET__ghCFu5jl__"